import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["colorField", "imageField"]

  connect() {
    this.updateVisibility()
  }

  select() {
    this.updateVisibility()
  }

  updateVisibility() {
    const selected = this.element.querySelector('input[name="video_config[background_type]"]:checked')?.value
    this.colorFieldTarget.classList.toggle("hidden", selected !== "color")
    this.imageFieldTarget.classList.toggle("hidden", selected !== "image")
  }
}
